<template>
    <div class="card card-form h-100">
        <!-- Toolbar -->
        <div class="card-header">
            <responsive>
                <div class="d-flex flex-nowrap" v-if="cropper == false">
                    <div class="btn-toolbar">
                        <button class="btn btn-primary" @click.prevent="$refs.upload.openDialog()" :disabled="scope == 'selected'">
                            <i class="fa fa-fw fa-cloud-upload-alt"></i> {{ $t('[[[Upload plików]]]') }}
                        </button>
                    </div>
                    <ul class="nav nav-tabs card-header-tabs mx-3">
                        <li v-for="item in scopes" :key="item.id" class="nav-item" @click="changeScope(item.id)">
                            <span class="nav-link text-nowrap" :class="{'active': item.id == scope}">
                                {{ item.label }}
                                <span class="badge badge-pill badge-success" v-if="item.id == 'selected' && checked.length > 0">{{ checked.length }}</span>
                            </span>
                        </li>
                    </ul>
                    <div class="btn-toolbar w-100">
                        <div class="input-group flex-nowrap search w-100">
                            <input type="text" :placeholder="$t('[[[Wyszukaj...]]]')" class="form-control" v-model="filter" @input="search">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" v-model="everywhere" @input="search" :title="$t('[[[Wyszukaj wszędzie]]]')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-toolbar ml-3">
                        <div class="btn-group" role="group">
                            <button class="btn" :class="[template == 'thumbs' ? 'btn-primary' : 'btn-secondary']" @click.prevent="changeTemplate('thumbs')" :title="$t('[[[Miniaturki]]]')" data-toggle="tooltip">
                                <i class="fa fa-fw fa-th"></i>
                            </button>
                            <button class="btn" :class="[template == 'list' ? 'btn-primary' : 'btn-secondary']" @click.prevent="changeTemplate('list')" :title="$t('[[[Szczegóły]]]')" data-toggle="tooltip">
                                <i class="fa fa-fw fa-th-list"></i>
                            </button>
                            <button class="btn" :class="[template == 'table' ? 'btn-primary' : 'btn-secondary']" @click.prevent="changeTemplate('table')" :title="$t('[[[Lista plików]]]')" data-toggle="tooltip">
                                <i class="fa fa-fw fa-list"></i>
                            </button>
                        </div>
                        <div class="btn-group ml-3 pl-3 border-left" role="group" v-if="modal">
                            <button class="btn btn-danger" :title="$t('[[[Zamknij]]]')" data-toggle="tooltip" @click.prevent="closeModal()">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-nowrap" v-if="cropper == true">
                    <div class="btn-toolbar ml-auto">
                        <div class="btn-group ml-3 pl-3" role="group">
                            <button class="btn btn-danger" :title="$t('[[[Zamknij]]]')" data-toggle="tooltip" @click.prevent="closeModal()" v-if="modal">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </responsive>
        </div>
        <!-- Files -->
        <div class="row no-gutters h-100 overflow" v-if="!cropper">
            <div class="col-xl-9 p-3 scroll">
                <drop-zone v-model="upload" :enabled="scope != 'selected'" :scope="scope" :folder="folder">
                    <files
                        :scope="scope" :media="media" :template="template" :breadcrumbs="breadcrumbs" :resources="resources" :selected="selected" :checked="checked" :pager="pager"
                        @change-folder="changeFolder" @sort-order="sortOrder" @sorted="sorted" @select-item="selectItem" @check-item="checkItem" @check-all="checkAll" @more="onPaging"
                    />
                </drop-zone>
            </div>
            <div class="col-xl-3 p-3 d-xl-block bg-light scroll" :class="{'d-none': scope === 'selected' || (upload.length == 0 && !selected)}">
                <div class="row no-gutters">
                    <div class="col-12 col-md-6 offset-md-3 col-xl-12 offset-xl-0">
                        <upload v-model="upload" :scope="scope" :folder="folder" @reload="loadData" ref="upload" v-show="upload.length > 0 && scope != 'selected'" />
                        <resource :resource="selected" :languages="languages" @reload="loadData" v-if="upload.length == 0 && selected" />
                        <div class="py-5 text-center text-muted" v-if="upload.length == 0 && !selected && scope !== 'selected'">
                            <i class="fas fa-crop fa-5x"></i>
                            <div class="pt-3">
                                {{ $t('[[[Wybierz plik lub katalog]]]') }}
                            </div>
                        </div>
                        <div class="py-5 text-center text-muted" v-if="upload.length == 0 && !selected && scope === 'selected'">
                            <i class="fas fa-hand-point-up fa-5x"></i>
                            <div class="pt-3">
                                {{ $t('[[[ Przeciągnij i upuść aby posortować pliki]]]') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Cropper -->
        <div class="h-100 scroll" v-if="cropper">
            <cropper :selected="selected" :enabled="cropper" @reload="loadData" />
        </div>
        <!-- Footer -->
        <buttons
            :scope="scope" :folder="folder" :selected="selected" :checked="checked" :modal="modal" :cropper="cropper"
            @reload="loadData" @deleted="deleted" @moved="moved"
        />
    </div>
</template>

<script>
import some from 'lodash/some';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import debounce from 'lodash/debounce';
import concat from 'lodash/concat';
import Pager from '@/helpers/Pager';
import StorageService from '@/services/core/StorageService';
import Files from './Files.vue';
import Upload from './Upload.vue';
import Resource from './Resource.vue';
import Buttons from './Buttons.vue';
import Cropper from './Cropper.vue';
import DropZone from './DropZone.vue';

export default {
    name: 'filemanager',
    components: {
        Files,
        Upload,
        Resource,
        Buttons,
        Cropper,
        DropZone
    },
    props: {
        'modal': {
            type: Boolean,
            default: false
        },
        'media': {
            type: String,
            default: 'files'
        }
    },
    data()
    {
        return {
            scope: 'public',
            template: 'thumbs',
            filter: '',
            everywhere: false,
            folder: null,
            scopes: [
                { id: 'public', label: this.$t('[[[Publiczne]]]') },
                { id: 'private', label: this.$t('[[[Prywatne]]]') },
                { id: 'selected', label: this.$t('[[[Wybrane]]]') }
            ],
            languages: this.$i18n.options(),
            breadcrumbs: [],
            resources: [],
            checked: [],
            selected: null,
            pager: new Pager(1, 50, 'name', 'ASC'),
            cropper: false,
            debounce: null,
            upload: []
        };
    },
    async created()
    {
        await this.loadData();
    },
    async mounted()
    {
        this.$events.$on('filemanager-button-cropper', this.enableCropper);

        if (this.modal)
        {
            document.body.style.overflow = 'hidden';
        }
    },
    async destroyed()
    {
        this.$events.$off('filemanager-button-cropper');

        if (this.modal)
        {
            document.body.style.overflow = 'auto';
        }
    },
    methods: {
        async loadData(append)
        {
            try
            {
                if (this.scope !== 'selected')
                {
                    let response = await StorageService.getResources(this.scope, this.folder, this.filter, this.everywhere, this.pager);

                    this.pager.setTotalRows(response.data.totalRows);
                    this.setBreadcrumbs(response.data.breadcrumbs);

                    if (append)
                        this.resources = concat(this.resources, response.data.items);
                    else
                        this.resources = response.data.items;
                }
                else
                {
                    this.pager.setTotalRows(this.checked.length);
                    this.setBreadcrumbs([]);
                    this.resources = this.checked;
                }
            }
            catch (ex)
            {
                this.pager.setTotalRows(0);
                this.items = [];

                this.$log.debug(ex);
            }
        },
        setBreadcrumbs(dictionary)
        {
            this.breadcrumbs = [];

            var keys = Object.keys(dictionary);

            for (let i = 0; i < keys.length; i++)
            {
                this.breadcrumbs.push({
                    id: keys[i],
                    label: dictionary[keys[i]]
                });
            }
        },
        changeScope(scope)
        {
            this.scope = scope;
            this.folder = null;
            this.selected = null;
            this.pager.setPageIndex(1);
            this.loadData();
        },
        changeFolder(e)
        {
            if (this.debounce)
            {
                this.debounce.cancel();
                this.debounce = null;
            }

            this.scope = e.scope;
            this.folder = e.folder;
            this.selected = null;
            this.pager.setPageIndex(1);
            this.loadData();
        },
        changeTemplate(name)
        {
            this.template = name;
        },
        search: debounce(function()
        {
            this.selectItem(null);
            this.filter = this.filter;
            this.everywhere = this.everywhere;
            this.pager.setPageIndex(1);
            this.loadData();
        },
        500),
        onPaging()
        {
            this.pager.setPageIndex(this.pager.getPageIndex() + 1);
            this.loadData(true);
        },
        sortOrder(e)
        {
            this.pager.setSort(e.column, e.order);
            this.pager.setPageIndex(1);
            this.loadData();
        },
        selectItem(item)
        {
            let self = this;

            if (this.debounce)
            {
                this.debounce.cancel();
                this.debounce = null;
            }

            this.debounce = debounce(function()
            {
                self.selected = self.selected === item ? null : item;
            },
            250);

            this.debounce();
        },
        checkItem(item)
        {
            if (!some(this.checked, p => p.resourceType === item.resourceType && p.id === item.id))
            {
                this.checked.push(item);
            }
            else
            {
                this.checked = filter(this.checked, p => !(p.resourceType === item.resourceType && p.id === item.id));
            }
        },
        checkAll(checkall)
        {
            let self = this;

            if (checkall)
            {
                forEach(this.resources, item =>
                {
                    if (!some(self.checked, p => p.resourceType === item.resourceType && p.id === item.id) && !this.disabled(item))
                    {
                        self.checked.push(item);
                    }
                });
            }
            else
            {
                this.checked = filter(this.checked, item =>
                {
                    return !some(self.resources, p => p.resourceType === item.resourceType && p.id === item.id);
                });
            }
        },
        disabled(item)
        {
            return this.media !== "files" && item.media.indexOf(this.media) === -1;
        },
        deleted()
        {
            this.checked = [];
            this.selected = null;
            this.pager.setPageIndex(1);
            this.loadData();
        },
        moved(data)
        {
            this.checked = filter(this.checked, p => (
                (p.resourceType === 'folder' && data.folders.indexOf(p.id) > -1) ||
                (p.resourceType === 'file' && data.files.indexOf(p.id) > -1)
            ));
            this.selected = null;
            this.pager.setPageIndex(1);
            this.loadData();
        },
        sorted(data)
        {
            this.checked = data;
            this.pager.setPageIndex(1);
            this.loadData();
        },
        enableCropper(enabled)
        {
            this.cropper = enabled;
        },
        closeModal()
        {
            this.$events.$emit('filemanager-modal-close', true);
        }
    },
    watch: {
        upload()
        {
            // console.log(this.upload);
        }
    }
};
</script>

<style scoped>
.search > input {
    min-width: 300px;
}
</style>
